import React from 'react';

const common = require('../common/common');
const env = require("../../config.js").default;

export class FilterUserTicket extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.userInfo = {};
        this.state.listAdminTicket = {};
        this.state.folder = this.props.folder
        this.state.actualAdmins = []
    }
    
    UNSAFE_componentWillMount(props) {
        common.getUserInfo().then(userInfo => {
            this.setState({ userInfo: userInfo });
        })
    }

    
    componentDidMount() {
        const $ = window.$;
        $(window).resize(function () {
            $('.select2').css('width', "100%");
        });

        $(".select_user_ticket").select2({
            placeholder: common.getTrad("Seleziona un utente"),
            language: common.getLanguage(),
            allowClear: true,
            width: '100%',
            dropdownAutoWidth: true,
        });

        $('#select_user_ticket').on('select2:clear', (e) => {
            e.preventDefault();
            $("select#select_user_ticket")[0].selectedIndex = -1;
            $("select#select_user_ticket").trigger('change');
            if(!window.cc.ticketFirebird){
                common.set_localStorage("valoreAdminTicket", JSON.stringify($('#select_user_ticket').val()));
            }
            return false;
        });
        if (window.cc.ticketFirebird) {
            this.updateIndexedDB()
        }
    }

    changeFilterHandler = () => {
        const $ = window.$;
        //common.add_UX_data(this.state.folder, "Filters", "Admin_filter", this.state.actualAdmins);
        this.props.sendData(this.state.actualAdmins);
    }

    updateIndexedDB() {
		//imposta il primo valore se l'indexedDB è popolato
		const $ = window.$;
		common.get_UX_component(this.state.folder, "Filters", "Admin_filter").then((admins) => {
			if (admins !== undefined && admins !== null && admins.length > 0) {
				$('#adminDot').css('visibility', 'visible')
            }
				this.setState({ actualAdmins: admins }, () => {
					this.changeFilterHandler();
					window.setTimeout(() => {
						$('select#select_user_ticket').val(admins).trigger("change");
					}, 200);
				});
		})
    }

    componentDidUpdate() {
        const $ = window.$;
        if (!window.cc.ticketFirebird) {
            if (common.get_localStorage("valoreAdminTicket") !== undefined && common.get_localStorage("valoreAdminTicket") !== null && common.get_localStorage("valoreNazione") !== '')
                $("select#select_user_ticket").val(JSON.parse(common.get_localStorage("valoreAdminTicket"))).trigger("change");
        }else{
            $('#select_user_ticket').on('select2:select', (e) => {
                this.state.actualAdmins = $('#select_user_ticket').val()
                this.changeFilterHandler();
                if ($('#select_user_ticket').val() !== "") {
                    $('#adminDot').css('visibility', 'visible')
                } else {
                    $('#adminDot').css('visibility', 'hidden')
                }
            })
            $('#select_user_ticket').on('select2:unselect', (e) => {
                this.state.actualAdmins = $('#select_user_ticket').val()
                this.changeFilterHandler();                
                if ($('#select_user_ticket').val().length === 0) {
                    $('#adminDot').css('visibility', 'hidden')
                }
            })            
        }
    }


    render(props) {
        return (
            <div className={(this.props.customClass !== undefined ? this.props.customClass : "col-xl-6 col-lg-6") + " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_modello">
                <div className="col-12 p-0">
                    {window.cc.ticketFirebird ?
                        <p>{common.getTrad("Filtra per admin")} <span id="adminDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px' }}></span></p>
                    :
                    <p>{common.getTrad("Filtra per admin")}</p>
                    }
                    <div className="form-group selectSwCustom">
                        <select name="select_user_ticket" className="form-control select_user_ticket" id="select_user_ticket" multiple="multiple">
                            {this.state.userInfo.list_admin_ticket !== undefined ?
                                this.state.userInfo.list_admin_ticket.map((index, key) => {
                                    return (
                                        <option key={key} value={index.CSOFT + '-' + index.ZUSER}>
                                            {index.RUSER}
                                        </option>
                                    )
                                })
                            :
                                <></>
                            }
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}

export class FilterUserTicketFirebird extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.listAdminTicket = [];
        this.state.folder = this.props.folder
        this.state.actualAdmins = []
    }

    UNSAFE_componentWillMount(props) {
        var apiUrl = env.SWAN + "utenti/ajax_get_utenti";
        var params = {
            'FADMI' : 'S',
            'ONLY_CW_ENABLED_USER': 1
        }
        common.apiCall(apiUrl, "GET", params, true, true, "json").then( admins => {
            this.setState({listAdminTicket : admins['data']})
        })
    }


    componentDidMount() {
        const $ = window.$;
        $(window).resize(function () {
            $('.select2').css('width', "100%");
        });

        $(".select_user_ticket").select2({
            placeholder: common.getTrad("Seleziona un utente"),
            language: common.getLanguage(),
            allowClear: true,
            width: '100%',
            dropdownAutoWidth: false,
            dropdownParent: $('#collapseFiltri')
        });

        
        $('#select_user_ticket').on('select2:clear', (e) => {
            e.preventDefault();
            $("select#select_user_ticket")[0].selectedIndex = -1;
            $("select#select_user_ticket").trigger('change');
            if (!window.cc.ticketFirebird) {
                common.set_localStorage("valoreAdminTicket", JSON.stringify($('#select_user_ticket').val()));
            }
            return false;
        });
        if (window.cc.ticketFirebird) {
            this.updateIndexedDB()
        }
    }

    changeFilterHandler = () => {
        const $ = window.$;
        //common.add_UX_data(this.state.folder, "Filters", "Admin_filter", this.state.actualAdmins);
        this.props.sendData(this.state.actualAdmins);
    }

    updateIndexedDB() {
        //imposta il primo valore se l'indexedDB è popolato
        const $ = window.$;
        common.get_UX_component(this.state.folder, "Filters", "Admin_filter").then((admins) => {
            if (admins !== undefined && admins !== null && admins.length > 0) {
                $('#adminDot').css('visibility', 'visible')
            }
            this.setState({ actualAdmins: admins }, () => {
                this.changeFilterHandler();
                window.setTimeout(() => {
                    $('select#select_user_ticket').val(admins).trigger("change");
                }, 200);
            });
        })
    }

    componentDidUpdate() {
        const $ = window.$;
        if (!window.cc.ticketFirebird) {
            if (common.get_localStorage("valoreAdminTicket") !== undefined && common.get_localStorage("valoreAdminTicket") !== null && common.get_localStorage("valoreNazione") !== '')
                $("select#select_user_ticket").val(JSON.parse(common.get_localStorage("valoreAdminTicket"))).trigger("change");
        } else {
            $('#select_user_ticket').on('select2:select', (e) => {
                this.state.actualAdmins = $('#select_user_ticket').val()
                this.changeFilterHandler();
                if ($('#select_user_ticket').val() !== "") {
                    $('#adminDot').css('visibility', 'visible')
                } else {
                    $('#adminDot').css('visibility', 'hidden')
                }
            })
            $('#select_user_ticket').on('select2:unselect', (e) => {
                this.state.actualAdmins = $('#select_user_ticket').val()
                this.changeFilterHandler();
                if ($('#select_user_ticket').val().length === 0) {
                    $('#adminDot').css('visibility', 'hidden')
                }
            })
        }
    }


    render(props) {
        return (
            <div className={(this.props.customClass !== undefined ? this.props.customClass : "col-xl-6 col-lg-6") + " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_modello">
                <div className="col-12 p-0">
                    {window.cc.ticketFirebird ?
                        <p>{common.getTrad("Filtra per admin")} <span id="adminDot" className="orange-dot" style={{ visibility: 'hidden', position: 'absolute', left: '-9px', top: '7px' }}></span></p>
                        :
                        <p>{common.getTrad("Filtra per admin")}</p>
                    }
                    <div className="form-group selectSwCustom">
                        <select name="select_user_ticket" className="form-control select_user_ticket" id="select_user_ticket" multiple="multiple">
                            {this.state.listAdminTicket !== undefined ?
                                this.state.listAdminTicket.map((index, key) => {
                                    return (
                                        <option key={key} value={index.CSOFT + '-' + index.ZUSER}>
                                            {index.RUSER}
                                        </option>
                                    )
                                })
                                :
                                <></>
                            }
                        </select>
                    </div>
                </div>
            </div>
        )
    }
}
